import type { ValueOf } from 'type-fest'

export const TunnelType = {
  ACCOUNT: 'account',
  LEAD: 'lead',
  STANDALONE: 'standalone',
} as const

export type TunnelType = ValueOf<typeof TunnelType>
